// Reference to CSS custom properties defined in @goodbye/design-tokens.
// Use these constants to avoid typo'd CSS var() strings in inline styles.
export const T = {
  paper: "var(--paper)",
  paperSink: "var(--paper-sink)",
  paperVeil: "var(--paper-veil)",
  ink900: "var(--ink-900)",
  ink700: "var(--ink-700)",
  ink500: "var(--ink-500)",
  ink350: "var(--ink-350)",
  ink200: "var(--ink-200)",
  ink100: "var(--ink-100)",
  veil08: "var(--ink-veil-08)",
  veil16: "var(--ink-veil-16)",
  veil40: "var(--ink-veil-40)",
  mono: "var(--font-mono)",
  han: "var(--font-han)",
} as const;

export type Token = typeof T[keyof typeof T];
